"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortsToQueryString = exports.SORT_DIRECTION = void 0;
exports.SORT_DIRECTION = {
    ASC: 'asc',
    DESC: 'desc',
};
/**
 * @description
 * Convert the sort options for Query into a query string
 *
 * @param sorts
 */
function sortsToQueryString(sorts) {
    const sortedSorts = Object
        .entries(sorts)
        .sort(([fA, sortA], [fB, sortB]) => sortA.sortIndex < sortB.sortIndex
        ? 1
        : sortA.sortIndex === sortB.sortIndex
            ? 0
            : -1);
    let queryParamsObject = {};
    // TODO: array methods instead of for loop
    for (let i = 0; i < sortedSorts.length; i++) {
        const [field, sort] = sortedSorts[i];
        queryParamsObject = Object.assign(Object.assign({}, queryParamsObject), {
            [`sort[${i}][field]`]: field,
            [`sort[${i}][direction]`]: sort.direction,
        });
    }
    return queryParamsObject;
}
exports.sortsToQueryString = sortsToQueryString;
